module.exports = __webpack_public_path__ + "img/time.fa6d6bcc.png";